<template>
  <div class="auth-wrapper">
    <div class="auth-container">
      <div class="auth-content-container">
        <v-card class="auth-card">
          <!-- TODO: Change domain name -->
          <div class="auth-title mb-1">{{ $t("auth.new_password") }}</div>
          <div class="auth-subtitle">{{ $t("auth.create_new_password") }}</div>
          <v-form ref="form" validate-on="validate" @submit.prevent="submit">
            <PasswordAndPasswordRepeatBlock v-model="form.password" />
            <v-btn color="primary" :loading="loading" @click="submit()" x-large class="auth-btn">
              {{ $t("auth.reset_password") }}
            </v-btn>
          </v-form>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
  import useAppConfig from "@core/@app-config/useAppConfig";
  import "cleave.js/dist/addons/cleave-phone.us";
  import PasswordAndPasswordRepeatBlock from "@/components/custom/PasswordAndPasswordRepeatBlock.vue";
  import { formErrorMessage } from "@/utility/formErrorMessage";

  export default {
    components: {
      PasswordAndPasswordRepeatBlock,
    },
    props: {
      token: {
        type: String,
        required: true,
      },
    },
    data() {
      const { appSkinVariant } = useAppConfig();

      return {
        appSkinVariant,
        form: {
          password: "",
          passwordRepeat: "",
        },
        loading: false,
      };
    },
    methods: {
      async submit() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          try {
            const response = await this.$admin.dataProvider.customHttpCall("POST", "auth/reset_password/change", {
              token: this.token,
              password: this.form.password,
            });

            if (response?.data?.user?.email) {
              this.$store.dispatch("SET_USER_DATA", response.data.user);
              this.$router.push({ name: "dashboard" });
            }
          } catch (e) {
            this.$admin.toast.error(formErrorMessage(e, this.$t("generic.error")));
            console.error(e);
            this.loading = false;
          } finally {
            this.loading = false;
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/functions.scss";
  @import "@core/preset/preset/typography/index.scss";
  ::v-deep {
    .new-password-field {
      margin-top: 24px !important;
      @media (min-width: 800px) {
        margin-top: 32px !important;
      }
    }
    .repeat-password-field {
      margin-top: 24px !important;
      @media (min-width: 800px) {
        margin-top: 32px !important;
      }
    }
  }
  .auth-wrapper {
    width: 100%;
    @media (min-width: 600px) {
      margin-top: 32px;
    }
    a {
      text-decoration: unset;
    }
  }

  .auth-container {
    display: flex;
    justify-content: center;
    padding: 4px;
    @media (min-width: 600px) {
      padding: 0;
    }
    .auth-content-container {
      width: 100%;
      @media (min-width: 600px) {
        width: 398px;
      }
    }
  }

  .auth-card {
    padding: 24px;
    border-radius: 6px;
    @media (min-width: 600px) {
      padding: 32px;
    }

    .auth-title {
      @include heading-4();
      color: get-color("headline");
      margin-bottom: 4px;
    }
    .auth-subtitle {
      @include text-body-2();
      color: get-color("subtitle");
    }

    .auth-btn {
      @include text-button-medium();
      background-color: get-color("primary");
      width: 100%;
      color: white;
      padding: 12px 54px;
      border-radius: 4px;
      margin-top: 24px !important;
      @media (min-width: 800px) {
        margin-top: 32px !important;
      }

      &:hover {
        background-color: get-color("primary-hover");
      }
    }
  }
</style>
